import { Menu } from 'antd';
import {
  AssegnaParereMassivoTipo,
  AttivitaDTO
} from 'client/api/backend/schemas';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { TaskActionLogic } from 'client/logic/TaskActionLogic';
import { IconWrapper } from 'client/ui/icon/IconWrapper';
import { UserLogic } from 'common/schema/user/UserLogic';
import React, { useState } from 'react';
import { ActionTypeTasksMassiveModal } from './ActionTypeTasksMassiveModal';

export interface ActionTypeTasksMassiveMenuItemProps {
  tasks: AttivitaDTO[];
  type: AssegnaParereMassivoTipo;
  icon: React.ReactNode;
  label: string;
  modalTitle: string;
  actionText: string;
  permission?: string;
}

/**
 * Elemento di menu per un'azione massiva di tipo dedicato
 */
export function ActionTypeTasksMassiveMenuItem(
  props: ActionTypeTasksMassiveMenuItemProps
) {
  const { tasks, type, icon, label, permission, modalTitle, actionText } =
    props;

  const user = useCurrentUser();
  const [visible, setVisible] = useState(false);

  const disabled = tasks.some(task => !TaskActionLogic.isAssigned(task, user));

  // Se non è autorizzato all'azione, nascondo l'opzione
  const hidden =
    permission != null && !UserLogic.hasPermission(user, permission);

  return (
    <>
      <Menu.Item
        disabled={disabled}
        hidden={hidden}
        key={`action-type-${type}`}
        onClick={() => setVisible(true)}
      >
        <IconWrapper icon={icon} /> {label}
      </Menu.Item>
      <ActionTypeTasksMassiveModal
        visible={visible}
        hide={() => setVisible(false)}
        tasks={tasks}
        type={type}
        modalTitle={modalTitle}
        actionText={actionText}
      />
    </>
  );
}
